itsoftApp.createModule("loadItems", function () {
    const module = this;

    const initLoad = function (section) {  
        const filters = section.querySelector(".js-filters"); //
        const loadTarget = section.querySelector(".js-load-target");
        const loadTrigger = section.querySelector(".js-load");
        let loadTriggerParent;
        let url;
        let filtersInited = false; //

        if (loadTrigger) {
            loadTriggerParent = section.querySelector(".js-load-parent") || loadTrigger.parentNode;
        }

        let pagination = section.querySelector(".js-pagination"); ///
        let paginationParent;
 
        if (pagination) {
            paginationParent = pagination.parentNode; ///
        }

        const sendRequest = function (onSuccess, onError, flag) {
            const xhr = new XMLHttpRequest();

            xhr.addEventListener("load", function () {
                if (xhr.status === 200 && onSuccess) {
                    if (flag) {
                        onSuccess(xhr.response, flag);
                    }
                } else {
                    onError(xhr.response);
                }
            });

            xhr.addEventListener("error", function () {
                onError("Произошла ошибка соединения");
            });
            xhr.addEventListener("timeout", function () {
                onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
            });

            xhr.timeout = 10000;

            xhr.open("GET", url);
            xhr.send();
        };

        const onErrorLoad = function (data) {
            console.log("error ", data);
        };

        const removeOldDataFromPage = function () {
            const cards = loadTarget.querySelectorAll(".js-load-item");

            for (var i = 0; i < cards.length; i++) {
                cards[i].parentNode.removeChild(cards[i]);
            }
        }

        const removeOldNavFromPage = function () {
            pagination = section.querySelector(".js-pagination");

            if (pagination) {
                paginationParent.removeChild(pagination);
            }
        }

        const addNewDataToPage = function (wrapper) {
            const newElements = wrapper.querySelectorAll(".js-load-item");  //  Ищем элементы

            if (newElements.length > 0) {
                const fragment = document.createDocumentFragment();

                /*** ***/
                const isAccordion = wrapper.querySelector(".js-accordion");

                if (isAccordion) {
                    new itsoftApp.modules.accordion.callback(isAccordion);
                }

                /*** ***/

                Array.prototype.forEach.call(newElements, function (newElement) {
                    fragment.appendChild(newElement);
                });

                loadTarget.appendChild(fragment);
            }
        }

        const addNewNavToPage = function (wrapper) {
            const newPagination = wrapper.querySelector(".js-pagination");//  Ищем навигацию
            const newLoadTrigger = wrapper.querySelector(".js-load"); // Ищем кнопку для загрузки доп. элементов

            if (newPagination) {
                const newPaginationLinks = newPagination.querySelectorAll(".js-pagination-link");

                if (newPaginationLinks.length > 0) {
                    Array.prototype.forEach.call(newPaginationLinks, function (newPaginationLink) {
                        if (newPaginationLink.hasAttribute("href")) {
                            newPaginationLink.addEventListener("click", onTogglePageClick);
                        }
                    });
                }

                paginationParent.appendChild(newPagination);
            }

            if (newLoadTrigger && loadTriggerParent) {
                if (loadTriggerParent.classList.contains("g-hidden")) {
                    loadTriggerParent.classList.remove("g-hidden")
                }

                loadTrigger.href = newLoadTrigger.href;
            } else {
                if (loadTriggerParent) {
                    loadTriggerParent.classList.add("g-hidden");
                } else {
                    /* TODO: сделать возможность добавления кнопки, если изначально её не было */
                }
            }
        }

        const onSuccessToggle = function (data, scrolling) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = data;

            removeOldDataFromPage();
            removeOldNavFromPage();
            addNewDataToPage(wrapper);
            addNewNavToPage(wrapper);

            if (scrolling) {
                itsoftApp.modules.animateScroll.callback(loadTarget, null, 500, 500, "easeInOutQuad", 15);
            }
        };

        const onSuccessLoad = function (data) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = data;

            removeOldNavFromPage();
            addNewDataToPage(wrapper);
            addNewNavToPage(wrapper);
        };

        const onLoadTriggerClick = function (evt) {
            evt.preventDefault();
            const button = evt.currentTarget;
            url = button.getAttribute("href");
            sendRequest(onSuccessLoad, onErrorLoad, true);
        };

        const onTogglePageClick = function (evt, urlRequest) {
            if (evt) {
                evt.preventDefault();
                const button = evt.currentTarget;
            }
            
            if (!urlRequest && button) {
                url = button.getAttribute("href") || button.getAttribute("data-href");
            } else {
                url = urlRequest;
            }

            sendRequest(onSuccessToggle, onErrorLoad, true);
        }

        if (loadTrigger) {
            loadTrigger.addEventListener("click", onLoadTriggerClick);
        }

        if (pagination) {
            const paginationLinks = section.querySelectorAll(".js-pagination-link");

            if (paginationLinks.length > 0) {
                Array.prototype.forEach.call(paginationLinks, function (paginationLink) {
                    if (paginationLink.hasAttribute("href")) {
                        paginationLink.addEventListener("click", onTogglePageClick);
                    }
                });
            }
        }

        if (filters && !filtersInited) {
            filtersInited = true;
            itsoftApp.modules.filters.init(section, onTogglePageClick);
        }
    };


    module.initLoad = initLoad;
});